import { DefaultOptions, QueryClient } from "@tanstack/react-query";

const defaultOptions: DefaultOptions = {
    queries: {
        useErrorBoundary: true,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
    },
};

export const queryClient = new QueryClient({ defaultOptions });
